var $ = require("jquery");

import "../scss/style.scss";
import "./script.js";
